/**
 * Camera damping factors. Respects prefers-reduced-motion per ENGN-05.
 * Consumed by Plan 05 when calling Phaser's cameras.main.startFollow.
 */

export const DEFAULT_LERP = { x: 0.1, y: 0.1 } as const

/**
 * Returns lerp factors for camera follow.
 * - prefersReducedMotion=true → {x:1, y:1} (snap, no damping)
 * - otherwise → DEFAULT_LERP (smooth follow)
 *
 * A fresh object is returned on every call so callers can safely mutate.
 */
export function cameraLerp(prefersReducedMotion: boolean): { x: number; y: number } {
  return prefersReducedMotion ? { x: 1, y: 1 } : { ...DEFAULT_LERP }
}
